import React from 'react';
import { Text } from 'core';

const ContactsList = () => {
  return <Text> Not Implemented yet</Text>;
};

export default ContactsList;



// WEBPACK FOOTER //
// ./src/components/modals/contacts_list.web.js